import React, { useState } from 'react';
import Moment from 'moment';
import Button from '@material-ui/core/Button';
import {
  CircularProgress,
  Typography,
  Grid,
  AppBar,
  Tabs,
  Tab,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import TabPanel from '../../../components/TabPanel';
import PatientChartConsultNotes from '../../../components/PatientChartConsultNotes';
import PatientChartAppts from '../../../components/PatientChartAppts';
import PatientChartApptReqs from '../../../components/PatientChartApptReqs';
import PatientProfile from '../../ProviderAdminPatients/components/PatientProfile';
import BookAppointmentModal from '../../ProviderAdminPatients/components/BookAppointmentModal';
import ConsultNoteEditModal from '../../../components/ConsultNoteEditModal';
import './style.css';
import { createConsultNote, updatePatient } from '../../../services/api';

const {
  standardizePhoneNumber,
} = require('../../../util/standardizePhoneNumber');

const userInfoForm = ({
  classes,
  firstName,
  lastName,
  phone,
  email,
  birthdate,
  gender,
  zipcode,
  guardians,
  isDependent,
  dependents,
  insuranceId,
  insuranceName,
  isConciergePatient,
  conciergeProvider,
  tebraPatientId,
}) => {
  return (
    <>
      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>Name</h4>
        <span className={classes.panelDetailsSectionText}>{firstName}</span>
      </div>

      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>Lastname</h4>
        <span className={classes.panelDetailsSectionText}>{lastName}</span>
      </div>

      {!isDependent && (
        <>
          <div className={classes.panelDetailsSection}>
            <h4 className={classes.panelDetailsSectionTitle}>Email</h4>
            <span className={classes.panelDetailsSectionText}>{email}</span>
          </div>

          <div className={classes.panelDetailsSection}>
            <h4 className={classes.panelDetailsSectionTitle}>Phone</h4>
            <span className={classes.panelDetailsSectionText}>
              {standardizePhoneNumber(phone) || '--'}
            </span>
          </div>

          <div className={classes.panelDetailsSection}>
            <h4 className={classes.panelDetailsSectionTitle}>Zip Code</h4>
            <span className={classes.panelDetailsSectionText}>{zipcode}</span>
          </div>
        </>
      )}

      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>Sex</h4>
        <span className={classes.panelDetailsSectionText}>{gender}</span>
      </div>

      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>DOB</h4>
        <span className={classes.panelDetailsSectionText}>
          {birthdate ? Moment.utc(birthdate).format('MM/DD/YYYY') : null}
        </span>
      </div>

      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>Patient's Tebra ID</h4>
        <span className={classes.panelDetailsSectionText}>{tebraPatientId}</span>
      </div>

      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionColouredTitle}>
          Insurance Name
        </h4>
        <span className={classes.panelDetailsSectionText}>
          {insuranceName || '--'}
        </span>
      </div>

      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionColouredTitle}>
          Insurance Id
        </h4>
        <span className={classes.panelDetailsSectionText}>
          {insuranceId || '--'}
        </span>
      </div>

      {isConciergePatient && <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionColouredTitle}>
        Qwell Concierge Member Of
        </h4>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {conciergeProvider.map((conciergeProviders,index) => (
            <span className={classes.panelDetailsSectionText} key={index}>
              {conciergeProviders.provider.user.userJoinName}
              {index < conciergeProvider.length - 1 && ", "}
            </span>
          ))}
        </div>
      </div>}

      {guardians && guardians.length > 0 && (
        <div className={classes.panelDetailsSection}>
          <h4 className={classes.panelDetailsSectionTitle}>{`Guardian${
            guardians.length > 1 ? 's' : ''
          }`}</h4>
          <div style={{ display: 'flex' }}>
            {guardians.map(guardian => (
              <span className={classes.panelDetailsSectionText}>
                {guardian.name}
              </span>
            ))}
          </div>
        </div>
      )}
      {dependents && dependents.length > 0 && (
        <div className={classes.panelDetailsSection}>
          <h4 className={classes.panelDetailsSectionTitle}>{`Dependent${
            dependents.length > 1 ? 's' : ''
          }`}</h4>
          <div style={{ display: 'flex' }}>
            {dependents.map(dependent => (
              <span className={classes.panelDetailsSectionText}>
                {dependent.name}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const PatientProfilePage = props => {
  const { classes, enqueueSnackbar, patient, setPatient, images } = props;

  const [loading, setLoading] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [tabPosition, setTabPosition] = useState(0);

  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);
  const [consultNotesModalOpen, setConsultNotesModalOpen] = useState(false);

  const onUpdatePatient = async patient => {
    try {
      setLoading(true);
      const updatedPatient = await updatePatient(patient);
      setPatient(updatedPatient);
      setEditMode(false);
    } catch {
      enqueueSnackbar('Oops, something went wrong. Please Try again');
    }
    setLoading(false);
  };

  const sendConsultNote = async noteParams => {
    try {
      await createConsultNote(noteParams);
      enqueueSnackbar('Successfully sent note!');
      setConsultNotesModalOpen(false);
    } catch (err) {
      enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  const downloadAll = () => {
    var link = document.createElement('a');

    link.setAttribute('download', 'attachment');
    link.style.display = 'none';

    document.body.appendChild(link);

    for (var i = 0; i < images.length; i++) {
      link.setAttribute('href', images[i].dataUrl);
      link.click();
    }

    document.body.removeChild(link);
  };
  return (
    <div className=" fullWidth">
      <div className={classes.root}>
        <header className={classes.header}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={3} lg={4}>
              <div className="headerSec">
                <Typography variant="h4" className={classes.headerText}>
                  Patients Profile
                </Typography>
              </div>
            </Grid>
            <Grid className="custom-row-btn" item xs={12} md={9} lg={8}>
              <div className="notifyPatientBtn">
                {images && images.length > 0 && (
                  <button
                    className="custom-attachment-btn popup-download-btn"
                    onClick={() => downloadAll()}
                  >
                    VIEW ATTACHMENT
                  </button>
                )
                //  <a className="custom-attachment-btn popup-download-btn" target='_blank' href={image && image.dataUrl} download >VIEW ATTACHMENT {index +1}</a>
                }

                <Button
                  className={`${classes.marginLeftAuto} ${classes.button}`}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    setEditMode(!isEditMode);
                    setTabPosition(0);
                  }}
                  disabled={isEditMode}
                >
                  Edit Patient Info
                </Button>
                <Button
                  className={`${classes.marginLeftTen} ${classes.button}`}
                  color="primary"
                  variant="contained"
                  onClick={() => setAppointmentModalOpen(true)}
                >
                  book/request appointment
                </Button>
                <Button
                  className={`${classes.marginLeftTen} ${classes.button}`}
                  color="primary"
                  variant="contained"
                  onClick={() => setConsultNotesModalOpen(true)}
                >
                  Message a Doc
                </Button>
                {/* <Button
              className={`${classes.marginLeftTen} ${classes.button}`}
              color="primary"
              variant="contained"
              onClick={() => setConsultNotesModalOpen(true)}
            >
              Message a Doc
            </Button> */}
                {/* <a className="popup-download-btn" target='_blank' href={image && image.dataUrl} download >Download</a>  */}
              </div>
            </Grid>
          </Grid>
        </header>
        <div className="notifyTableMenu">
          <Grid container className={classes.marginBottomFourtyEight}>
            <AppBar position="static" color="default">
              <Tabs
                value={tabPosition}
                onChange={(e, position) => setTabPosition(position)}
              >
                <Tab label="Profile" />
                <Tab label="Appointments" />
                <Tab label="Requests/Referrals" />
                <Tab label="Doc to Doc Messages" />
              </Tabs>
            </AppBar>
            {tabPosition === 0 && (
              <TabPanel>
                {loading ? (
                  <CircularProgress className={classes.loading} />
                ) : (
                  <Grid container>
                    <Grid item xs={12} md={5} lg={4}>
                      {isEditMode ? (
                        <PatientProfile
                          patient={patient}
                          onSubmit={onUpdatePatient}
                          source="miniPatientProfile"
                          onClose={() => {
                            setEditMode(!isEditMode);
                            setTabPosition(0);
                          }}
                          backButtonText="Cancel"
                        />
                      ) : (
                        userInfoForm({
                          classes,
                          ...patient,
                        })
                      )}
                    </Grid>
                  </Grid>
                )}
              </TabPanel>
            )}
            {tabPosition === 1 && (
              <TabPanel className={classes.overflowXAuto}>
                <PatientChartAppts patientId={patient.id} />
              </TabPanel>
            )}
            {tabPosition === 2 && (
              <TabPanel className={classes.overflowXAuto}>
                <PatientChartApptReqs patientId={patient.id} />
              </TabPanel>
            )}
            {tabPosition === 3 && (
              <TabPanel className={classes.overflowXAuto}>
                <PatientChartConsultNotes patientId={patient.id} />
              </TabPanel>
            )}
          </Grid>
        </div>
        {appointmentModalOpen && (
          <BookAppointmentModal
            open={appointmentModalOpen}
            patient={patient}
            closeDialog={() => {
              setAppointmentModalOpen(false);
            }}
          />
        )}

        <ConsultNoteEditModal
          patient={patient}
          open={consultNotesModalOpen}
          save={sendConsultNote}
          onClose={() => {
            setConsultNotesModalOpen(false);
          }}
        />
      </div>
    </div>
  );
};

const styles = () => ({
  overflowXAuto: {
    overflowX: 'auto',
  },
  loading: {
    display: 'block',
    margin: 'auto',
  },
  root: {
    padding: '3em',
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  list: {
    paddingBottom: '2em',
  },
  panelDetailsSection: {
    paddingBottom: '34px',
  },
  panelDetailsSectionTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  panelDetailsSectionColouredTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'bold',
  },
  panelDetailsSectionText: {
    color: '#1C2B39',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '19px',
  },
  marginBottomFourtyEight: {
    marginBottom: 48,
  },
  marginLeftTen: {
    marginLeft: 10,
  },
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  button: {
    marginBottom: 10,
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
    },
  },
  backLink: {
    marginBottom: 15,
  },
});

export default withSnackbar(withStyles(styles)(PatientProfilePage));
